module.exports = __webpack_public_path__ + "static/media/3star.38fafe09.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/3star.png
// module id = 473
// module chunks = 0